(() => {
  // ────────────────────────────────────────────────────────────────────────────
  // Guard: prevent double-init if this snippet is included more than once
  // ────────────────────────────────────────────────────────────────────────────
  if (window.__CB_OPUS_INIT__) return;
  window.__CB_OPUS_INIT__ = true;

  // ────────────────────────────────────────────────────────────────────────────
  // Icon URLs (scoped so they won't clash with other files)
  // ────────────────────────────────────────────────────────────────────────────
  const ICONS = {
    ACTIVE:   'https://cdn.shopify.com/s/files/1/0684/6519/7273/files/Untitled_design_8a4a3920-6299-44ba-90a6-83218a32dd20.png?v=1753509245', // white star
    INACTIVE: 'https://cdn.shopify.com/s/files/1/0684/6519/7273/files/1_02bd5dc8-a2f9-45ed-8719-25545e578f17.png?v=1753451977'              // black star
  };

  // ────────────────────────────────────────────────────────────────────────────
  // Helpers
  // ────────────────────────────────────────────────────────────────────────────
  function formatCart(cart) {
    const fmt = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    });
    return {
      original_total_price: cart.original_total_price,
      total_price:          cart.total_price,
      oPriceMoney:          fmt.format(cart.original_total_price / 100),
      money:                fmt.format(cart.total_price / 100),
      item_count:           cart.item_count
    };
  }

  function updateRewardIcons() {
    // tiny defer so Opus/DOM finish their own updates first
    setTimeout(() => {
      const nodes = document.querySelectorAll('.cd-icon-container-wrapper [class^="cd-icon-reward-"]');
      nodes.forEach(icon => {
        const inner = icon.querySelector('.cd-icon-inner');
        if (!inner) return;

        let img = inner.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.width  = 20;
          img.height = 20;
        }

        img.src = icon.classList.contains('op_active') ? ICONS.ACTIVE : ICONS.INACTIVE;
        inner.innerHTML = '';
        inner.appendChild(img);
      });
    }, 0);
  }

  function renderSummaryAndGift(detail) {
    // 1) Replace/insert the Total block
    const oldTotalEl = document.querySelector('.opus-price-ct-container');
    if (oldTotalEl) oldTotalEl.remove();

    const header = document.querySelector('.cd-checkout-section-header');
    if (header) {
      const hasDiscount = detail.original_total_price - detail.total_price > 0;
      header.insertAdjacentHTML('afterend', `
        <div class="opus-price-ct-container" style="
          width:100%;
          display:inline-flex;
          padding-bottom:15px;
          justify-content:space-between;
          align-items:center;
          font-size:14px;
          font-weight:bold;
          gap:20px;
          margin:auto;">
          <span style="flex-shrink:0;margin-right:10px;"><strong>Total:</strong></span>
          <span style="text-align:center;">
            <span style="
              font-size:14px!important;
              color:grey;
              text-decoration:line-through;
              font-weight:400!important;
              margin-left:5px;">
              ${ hasDiscount ? detail.oPriceMoney : '' }
            </span>
            ${ detail.money }
          </span>
        </div>
      `);
    }

    // 2) Mystery Gift line (₹999 threshold)
document.querySelectorAll('.my-gift-line').forEach(el => el.remove());
const tierEl = document.querySelector('.cd-icon-container-wrapper');
if (tierEl) {
  const totalRupees = detail.total_price / 100;
  const threshold   = 999;
  const unlocked    = totalRupees >= threshold;
  const message     = unlocked
    ? 'Mystery Gift has been unlocked! 🎉'
    : 'Mystery Gift unlocks at ₹999';

  tierEl.insertAdjacentHTML('afterend', `
    <div class="my-gift-line">
      <span class="my-gift-badge ${unlocked ? 'is-unlocked' : 'is-locked'}">
        <span class="my-gift-emoji" aria-hidden="true">🎁</span>
        <span class="my-gift-text">${message}</span>
      </span>
    </div>
  `);
}

    // 3) Swap the reward tier icons
    updateRewardIcons();
  }

  // ────────────────────────────────────────────────────────────────────────────
  // Listeners
  // ────────────────────────────────────────────────────────────────────────────
  // Rebuild custom UI whenever Opus broadcasts a cart change
  window.addEventListener('OpusCartChange', (e) => renderSummaryAndGift(e.detail));

  // Sync Shopify cart when quantity inputs change (and then broadcast)
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!input.matches('input.quantity__input[data-quantity-variant-id]')) return;

    const variantId = input.dataset.quantityVariantId;
    const quantity  = parseInt(input.value, 10);
    if (!variantId || isNaN(quantity)) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    })
      .then(res => res.json())
      .then(cart => {
        const detail = formatCart(cart);
        window.dispatchEvent(new CustomEvent('OpusCartChange', { detail }));
      })
      .catch(console.error);
  });

  // ────────────────────────────────────────────────────────────────────────────
  // Boot: once DOM is ready, fetch the current cart and render immediately
  // ────────────────────────────────────────────────────────────────────────────
  function boot() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const detail = formatCart(cart);
        window.dispatchEvent(new CustomEvent('OpusCartChange', { detail }));
      })
      .catch(console.error);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
